import { createMutationHook } from '~/shared/providers/api';

export const useInviteCustomerMutation = createMutationHook(
  'crm.customerInvite',
  (params: { accountId: string; email?: string }) => ({
    crmCustomerInvite: {
      __args: {
        input: {
          accountId: params.accountId,
          email: params.email,
        },
      },
      id: true,
      accountId: true,
      email: true,
      invitationStatus: true,
      sentAt: true,
      expiresAt: true,
      account: {
        id: true,
        name: true,
      },
    },
  }),
);
